import React from 'react';
import PropTypes from 'prop-types';
import VmGasModal from '../vm-gas-modal';
import UserJMBaseContent from './userJMBaseContent';
import SecurityCheckRecord from './securityCheckRecord';
const TABS_BASE = 'gas-user-base';
const TABS_SECURITYCHECKRECORD = 'gas-user-security-check-record';
const UserJMModal = ({ info, urlHead, ...resetProps }) => {
    const tabs = [
        {
            value: '详情',
            content: <UserJMBaseContent info={info} urlHead={urlHead} />,
            key: TABS_BASE,
        },
        {
            value: '入户安检记录',
            content: <SecurityCheckRecord id={info.id} urlHead={urlHead} />,
            key: TABS_SECURITYCHECKRECORD,
        },
    ];
    return <VmGasModal title="用户（居民）" {...resetProps} tabs={tabs} />;
};

UserJMModal.propTypes = {
    info: PropTypes.object,
    urlHead: PropTypes.object,
};

export default UserJMModal;
